import * as CONST  from '../constants';
import {scrollToTop} from '../lib/helpers';

export function updateNavBarIndex(idx) {
    // console.log("updateNavBarIndex", idx);
    scrollToTop();
    return {
        type: CONST.SET_NAV_INDEX,
        payload: idx,
    };
}

export function disableNavItems(items, index, value) {
    const newArray = items;
    newArray[index] = value;
    return {
        type: CONST.DISABLE_NAV,
        payload: [...newArray],
    };
}

export function setShoppingCart(cart) {
    cart.totalGst = 0;
    for (let i=0; i<cart.items.length; i++) {
        let item = cart.items[i];
        item.hasGst = item.type === "GiftCard" || item.experience?.venue?.state;
        if (item.program?.excludeGST) { item.hasGst = false; }
        if (item.hasGst) {
          cart.totalGst += (item.amount / 11);
        }
        cart.items[i] = item;
    }
    return {
        type: CONST.SET_SHOPPING_CART,
        payload: cart,
    };
}

export function setFinalCart(cart) {
    return {
        type: CONST.SET_FINAL_CART,
        payload: cart
    };
}

export function setDonation(amt) {
    return { type: CONST.SET_DONATION, payload: amt };
}

export function setDonationError(b) {
    return { type: CONST.SET_DONATION_ERROR, payload: b };
}

export function setAlertMessage(isOpen, alertStatus, alertText) {
    const alertObject = {
        isOpen: isOpen || false,
        status: alertStatus || null,
        text: alertText || "",
    };
    return {
        type: CONST.SET_ALERT_MSG,
        payload: alertObject,
    };
}

export function setHero(title, image, mobileImage) {
    return {
        type: CONST.SET_HERO,
        payload: {title, image, mobileImage}
    }
}

export function fetchHeader(METHOD, BODY) {
    switch (METHOD) {
    case 'GET':
        return {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',
            },
        };
    case 'POST':
        return {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
            },
            body: BODY,
        };
    case 'PATCH':
        return {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
            },
            body: BODY,
        };
    case 'DELETE':
        return {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',
            },
        };
    default:
        return {};
    }
}

export function fetchData(_endpoint, _method, _body) {
    return () => {
        return new Promise((resolve, reject) => {
            fetch(`${process.env.RAZZLE_ADE_API}${_endpoint}`, fetchHeader(_method, JSON.stringify(_body)))
            .then(response => {
                const myres = response.clone();
                // TODO: is there a better way to handle empty response?
                myres.text().then((text) => {
                    if (text === '') {
                        // empty response return empty object
                        return resolve({});
                    } else {
                        if (response.status === 200) {
                            return resolve(response.json());
                        } else if (!response.ok) {
                            return reject(response.json());
                        }
                    }
                });
            });
        });
    };
}
